export default "__VITE_ASSET__objYshEm__"